import React from 'react';
import { Image } from 'semantic-ui-react';

import PDFPreview from './PDFPreview';
import { ImageTypes } from '../../utils/attachmentTypes';
import Crop from '../Crop';

const Basic = ({
  src,
  attachmentType,
  onCrop,
  onClick,
  zoomablePDF,
  editDisabled
}) => {
  if (ImageTypes.includes(attachmentType)) {
    return onCrop ? (
      <Crop src={src} onCrop={onCrop} adjustable disabled={editDisabled} />
    ) : (
      <Image src={src} onClick={onClick} />
    );
  }
  if (attachmentType === 'application/pdf') {
    return (
      <PDFPreview
        editDisabled={editDisabled}
        src={src}
        zoomable={zoomablePDF}
        croppable={!!onCrop}
        onCropComplete={onCrop}
        onClose={onClick}
      />
    );
  }
  return <p style={{ textAlign: 'center' }}>Document type is not supported</p>;
};

export default Basic;



// WEBPACK FOOTER //
// ./src/component/DocumentPreview/Basic.js